/**
 * Страница объекта
 * @return Boolean
 */
const isHotelPage = () => {
    return !!document.querySelector('.js-hotelData');
}

/**
 * Метод отправки запроса
 * @return Promise
 */
export const ajaxGetData = () => {
    let formData;
    if (isHotelPage()) {
        formData = new FormData();
        formData.append('hotel_id', document.querySelector('.js-hotelData').dataset.hotel_id);
    } else {
        formData = new FormData();
    }

    if (window.pageData && window.pageData.page_id) {
        formData.append('page_id', window.pageData.page_id);
    }

    if (window.pageData && window.pageData.page_type_id) {
        formData.append('page_type_id', window.pageData.page_type_id);
    }

    const orderSuccessMatch = location.pathname.match(/\/order\/success\/(\d+)\//);
    if (orderSuccessMatch) {
        formData.append('order_success_id', orderSuccessMatch[1]);
    }

    if (!window.ajaxGetData) {
        window.ajaxGetData = new Promise((resolve, reject) => {
            fetch('/main/get_ajax_data/', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData,
            })
            .then(response => response.json())
            .then(r => {
                if (r.status === 'ok') {
                    window.tourist_auth = r.data?.tourist_auth;

                    resolve(r);
                }
            })
            .catch(() => {
                resolve({
                    status: 'ok',
                    data: {
                        search: {},
                    },
                    modals: '',
                });
            });
        });
    }

    return window.ajaxGetData;
}

/**
 * Отправляем данные для сохранения
 */
export const ajaxSetData = (formData) => {
    if (formData instanceof FormData) {
        return new Promise((resolve, reject) => {
            fetch('/main/set_ajax_data/', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData,
            })
            .then(response => response.json())
            .then(r => {
                if (r.status === 'ok') {
                    window.tourist_auth = r.data?.tourist_auth;

                    resolve(r);
                }
            });
        });
    }

    // Object
    let data = formData;
        formData = new FormData();

    for (let i in data) {
        formData.append(i, data[i]);
    }

    return ajaxSetData(formData);
}
